import { KB_NOT_GRATIS, KB_PROMO_PATTERNS, statesStandingOffer } from "./concessions";

/**
 * X3 RAIL fix round 1 (CLAUDE.md section 0.5): the ONE list and the ONE reader of offer wording for
 * anything the owner or a catalog puts into a customer message without typing it for that customer
 * at send time: a saved snippet, a quoted knowledge fact, a product name or its link.
 *
 * `statesStandingOffer` reads a discount, a price match, a figure off. It passes "holiday sale",
 * "special offer", "free engraving", "clearance" and a /sale/ link. The word list below closes that,
 * and the union (`holdsOfferWording`) is what the rail applies. It is the same list as X2's
 * `readOfferWording` (X2 core/catalog.ts), written here once so the integrator can point X2 and the
 * fixedLinesNoOffer pin at this module. "free" is read after `KB_NOT_GRATIS` removes the ordinary
 * uses ("conflict-free", "free of nickel", "feel free"). A held text is fixed at its source, never
 * loosened here. AWAITING RATIFICATION.
 */
export const OFFER_WORD_RE =
  /\b(?:sales?|deals?|offers?|offered|offering|promos?|promotions?|promotional|specials?|coupons?|freebies?|free|saves?|saving|savings|cheap|cheaper|cheapest|bargains?|discount(?:s|ed)?|clearance|mark[\s-]*downs?|bogo|outlet)\b|%\s*off\b|\bper\s?cent\s+off\b|\bpercent\s+off\b|\blimited[\s-]+time\b/i;

/** The first offer wording in `text`, or null. */
export function readOfferWording(text: string): string | null {
  let t = text;
  for (const p of KB_NOT_GRATIS) t = t.replace(new RegExp(p.source, p.flags.includes("g") ? p.flags : `${p.flags}g`), " ");
  const word = OFFER_WORD_RE.exec(t);
  if (word) return word[0].toLowerCase();
  for (const p of KB_PROMO_PATTERNS) {
    const hit = new RegExp(p.source, p.flags.replace("g", "")).exec(t);
    if (hit) return hit[0].toLowerCase();
  }
  return null;
}

/** A link read as words: decoded, with the separators of a path and a query turned to spaces. */
export function urlWords(url: string): string {
  let u = url;
  try {
    u = decodeURIComponent(url);
  } catch {
    // an undecodable link is read as typed
  }
  return u.replace(/^https?:\/\//i, "").replace(/[/_.\-+=&?#:]+/g, " ");
}

/**
 * The offer wording `text` carries (a standing-offer statement, an offer word, or an offer word in the
 * decoded path or query of a link inside it), or null when it carries none.
 */
export function holdsOfferWording(text: string): string | null {
  if (statesStandingOffer(text)) return "standing offer";
  const direct = readOfferWording(text);
  if (direct) return direct;
  for (const link of text.match(/https?:\/\/[^\s]+/gi) ?? []) {
    const hit = readOfferWording(urlWords(link));
    if (hit) return hit;
  }
  return null;
}
